import styled from "styled-components";

export const MagicLinkBox = styled.a`
    position: absolute;
    display: block;
`;
